export const PUBLICATIONS_TAG_TYPE = 'Publications' as const;
